/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type AnonymousPersonCreateReq,
    AnonymousPersonCreateReqFromJSON,
    AnonymousPersonCreateReqToJSON,
} from '../models/AnonymousPersonCreateReq';
import {
    type PostPersonsAnonymous201Response,
    PostPersonsAnonymous201ResponseFromJSON,
    PostPersonsAnonymous201ResponseToJSON,
} from '../models/PostPersonsAnonymous201Response';
import {
    type PostPersonsPersonIdImpersonate201Response,
    PostPersonsPersonIdImpersonate201ResponseFromJSON,
    PostPersonsPersonIdImpersonate201ResponseToJSON,
} from '../models/PostPersonsPersonIdImpersonate201Response';
import {
    type PostPersonsPersonIdImpersonateV2Request,
    PostPersonsPersonIdImpersonateV2RequestFromJSON,
    PostPersonsPersonIdImpersonateV2RequestToJSON,
} from '../models/PostPersonsPersonIdImpersonateV2Request';

export interface PostPersonsAnonymousRequest {
    slashIDOrgID: string;
    anonymousPersonCreateReq: AnonymousPersonCreateReq;
    slashIDSdkVersion?: string;
}

export interface PostPersonsPersonIdImpersonateRequest {
    personId: string;
    slashIDOrgID: string;
}

export interface PostPersonsPersonIdImpersonateV2OperationRequest {
    personId: string;
    slashIDOrgID: string;
    postPersonsPersonIdImpersonateV2Request?: PostPersonsPersonIdImpersonateV2Request;
}

/**
 * 
 */
export class PersonsApi extends runtime.BaseAPI {

    /**
     * Creates request options for postPersonsAnonymous without sending the request
     */
    async postPersonsAnonymousRequestOpts(requestParameters: PostPersonsAnonymousRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postPersonsAnonymous().'
            );
        }

        if (requestParameters['anonymousPersonCreateReq'] == null) {
            throw new runtime.RequiredError(
                'anonymousPersonCreateReq',
                'Required parameter "anonymousPersonCreateReq" was null or undefined when calling postPersonsAnonymous().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/persons/anonymous`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnonymousPersonCreateReqToJSON(requestParameters['anonymousPersonCreateReq']),
        };
    }

    /**
     * Create a new anonymous person linked to your organization. Unlike regular persons, anonymous persons\' identities are unknown and they do not have any authentication methods. However, it is still possible to persist information associated with this user, including attributes and GDPR consent. Anonymous persons can be created when a user first enters your website or application. If the person eventually signs up, the person type is upgraded to regular. Anonymous persons are inherently temporary and will be deleted after 30 days. Anonymous persons do not count towards billing and account limits, but their creation is rate-limited based on the organization\'s pricing tier. 
     * Create new anonymous person
     */
    async postPersonsAnonymousRaw(requestParameters: PostPersonsAnonymousRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPersonsAnonymous201Response>> {
        const requestOptions = await this.postPersonsAnonymousRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPersonsAnonymous201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new anonymous person linked to your organization. Unlike regular persons, anonymous persons\' identities are unknown and they do not have any authentication methods. However, it is still possible to persist information associated with this user, including attributes and GDPR consent. Anonymous persons can be created when a user first enters your website or application. If the person eventually signs up, the person type is upgraded to regular. Anonymous persons are inherently temporary and will be deleted after 30 days. Anonymous persons do not count towards billing and account limits, but their creation is rate-limited based on the organization\'s pricing tier. 
     * Create new anonymous person
     */
    async postPersonsAnonymous(requestParameters: PostPersonsAnonymousRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPersonsAnonymous201Response> {
        const response = await this.postPersonsAnonymousRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postPersonsPersonIdImpersonate without sending the request
     */
    async postPersonsPersonIdImpersonateRequestOpts(requestParameters: PostPersonsPersonIdImpersonateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling postPersonsPersonIdImpersonate().'
            );
        }

        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postPersonsPersonIdImpersonate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/persons/{person_id}/impersonate`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */
    async postPersonsPersonIdImpersonateRaw(requestParameters: PostPersonsPersonIdImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPersonsPersonIdImpersonate201Response>> {
        const requestOptions = await this.postPersonsPersonIdImpersonateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPersonsPersonIdImpersonate201ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */
    async postPersonsPersonIdImpersonate(requestParameters: PostPersonsPersonIdImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPersonsPersonIdImpersonate201Response> {
        const response = await this.postPersonsPersonIdImpersonateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for postPersonsPersonIdImpersonateV2 without sending the request
     */
    async postPersonsPersonIdImpersonateV2RequestOpts(requestParameters: PostPersonsPersonIdImpersonateV2OperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling postPersonsPersonIdImpersonateV2().'
            );
        }

        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling postPersonsPersonIdImpersonateV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/persons/{person_id}/impersonate/v2`;
        urlPath = urlPath.replace('{person_id}', encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostPersonsPersonIdImpersonateV2RequestToJSON(requestParameters['postPersonsPersonIdImpersonateV2Request']),
        };
    }

    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */
    async postPersonsPersonIdImpersonateV2Raw(requestParameters: PostPersonsPersonIdImpersonateV2OperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostPersonsPersonIdImpersonate201Response>> {
        const requestOptions = await this.postPersonsPersonIdImpersonateV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPersonsPersonIdImpersonate201ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */
    async postPersonsPersonIdImpersonateV2(requestParameters: PostPersonsPersonIdImpersonateV2OperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostPersonsPersonIdImpersonate201Response> {
        const response = await this.postPersonsPersonIdImpersonateV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
